import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal } from './Common';
import { ScrollCard } from './ScrollCard';
import { f3dTeaser, f3dHeroImage } from '../fantasti3dData';
import '../styles/fantasti3d.css';

export const Fantasti3DTeaser = () => <section id="fantasti3d" className="f3d-teaser section-pad" data-testid="fantasti3d-teaser">
  <div className="f3d-teaser-grid">
    <Reveal className="f3d-teaser-copy">
      <span className="eyebrow f3d-eyebrow" data-testid="fantasti3d-teaser-eyebrow">{f3dTeaser.eyebrow}</span>
      <h2 className="display-heading" data-testid="fantasti3d-teaser-title">{f3dTeaser.title[0]}<br /><em>{f3dTeaser.title[1]}</em></h2>
      <p className="f3d-teaser-sub" data-testid="fantasti3d-teaser-sub">{f3dTeaser.subtitle}</p>
      <p className="f3d-teaser-text">{f3dTeaser.text}</p>
      <Link to="/fantasti3d" className="button button-gold f3d-teaser-cta" data-testid="fantasti3d-teaser-cta">{f3dTeaser.cta} <ArrowUpRight size={19} /></Link>
    </Reveal>
    <ScrollCard className="f3d-teaser-media" index={1}>
      <img src={f3dHeroImage} alt="Stampante 3D di grande formato che realizza un grande mascherone di Carnevale, con layer di stampa visibili" loading="lazy" />
      <span className="f3d-teaser-badge" aria-hidden="true">STAMPA 3D · GRANDE FORMATO</span>
    </ScrollCard>
  </div>
</section>;
